import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export function useGetApplications() {
  const { data, isLoading } = useQuery(
    ["applications"],
    () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/application`)
        .then((response) => {
          return response.data;
        }),
    {
      refetchOnWindowFocus: false,
    }
  );



  return {
    data,
    loading: isLoading,
  };
}


